import React from 'react'
// eslint-disable-next-line import/named
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import { COLORS } from '../styles/variables'

export const IconStatus: React.FC<SvgIconProps> = ({sx}) => (
  <SvgIcon
    viewBox="0 0 17 16"
    sx={{
      color: COLORS.CERULEAN,
      width: 17, 
      height: 16,
      ...sx,
    }}
  >
    <path 
        d="M16.3597 0.176219C16.0353 -0.00712285 15.6404 -0.0635356 15.2526 0.0845479L6.16309 3.49752C6.01501 3.54688 5.85988 3.57509 5.70474 3.57509H1.30455C0.585282 3.57509 0 4.16742 0 4.88668L0.0141032 9.75229C0.0141032 10.2318 0.275012 10.6549 0.669902 10.8805C0.860295 10.9934 1.08595 11.0568 1.31865 11.0568H5.00663V14.9282C5.00663 15.323 5.22523 15.6686 5.54255 15.859C5.69769 15.9506 5.88103 16 6.07847 16C6.67081 16 7.15032 15.5205 7.15032 14.9282V11.5011L15.2456 14.5403C16.0988 14.8576 17.0084 14.23 17.0084 13.3204V1.30447C17.0155 0.810862 16.7475 0.394818 16.3597 0.176219ZM14.7801 11.9665L6.97403 9.04007C6.57209 8.89199 6.15604 8.81442 5.7259 8.81442H2.24946L2.24241 5.8175H5.70474C6.12784 5.8175 6.55093 5.73993 6.95287 5.59184L14.7872 2.65133L14.7801 11.9665Z"
        stroke="none"
        fill="currentColor"
    />
    
  </SvgIcon>
)
